import { Card, CardMedia, CardContent, Typography, CardActions, Avatar, Rating, IconButton } from "@mui/material";
import React, { ComponentPropsWithoutRef, useState, useEffect } from "react";
import { deleteEmbed } from "../../../../api/endpoints";
import placeholder from "../../../../assets/video_placeholder.png";
import { formatVideoName, IVideo } from "../hooks/useFetchVideos";
import { Delete } from "@mui/icons-material";
import { VideoCardMenuV2 } from "./VideoCardMenuV2";
import { VariationReviewModal } from "../../../videoProduction/components/videoReview/VariationReviewModal";

interface VideoCardProps extends ComponentPropsWithoutRef<"div"> {
    onClick: () => void;
    onDelete?: () => void;
    video: IVideo;
    project?: any;
}

export function VideoCard(props: VideoCardProps) {
    const { onClick, onDelete, video, project: propProject } = props;
    const project = propProject || video.project;
    const [source, setSource] = useState("");
    const [hoverState, setHoverState] = useState<boolean>(false);
    const [showMenu, setShowMenu] = useState(false);
    const [showVariationReview, setShowVariationReview] = useState(false);

    useEffect(() => {
        let url = video.location || video.reviewS3File?.location || placeholder;
        setSource(url?.replace(".mp4", "_thumbnail.png") || "");
    }, [video]);

    const formatName = (videoObject: any) => {
        const name = videoObject?.title || videoObject?.name || videoObject?.key || "";
        return formatVideoName(name);
    };

    const formatAuthor = (videoObject: any) => {
        const name = videoObject.author?.first_name || "";
        return name;
    };

    const handleReviewVideo = () => {
        setShowVariationReview(true);
    };

    return (
        <Card
            sx={{ maxWidth: 345, ":hover": { cursor: "pointer" }, position: "relative" }}
            elevation={hoverState ? 10 : 1}
            onMouseOver={() => setHoverState(true)}
            onMouseLeave={() => setHoverState(false)}
            title={formatName(video)}
        >
            <div onClick={onClick}>
                <CardMedia
                    component="img"
                    height="140"
                    style={{ maxHeight: "160px", objectFit: "cover", width: "100%" }}
                    image={source}
                    alt=""
                />
                <CardContent>
                    <Typography gutterBottom component="div">
                        {video?.aspect_ratio}
                        <br />
                        {formatName(video)}
                    </Typography>
                    <Typography fontWeight={400} fontSize={14} color="text.secondary">
                        {video.rating && <Rating name="read-only" value={video.rating} precision={0.5} readOnly />}
                    </Typography>
                    <Typography fontWeight={400} fontSize={14} color="text.secondary">
                        {video.review_text}
                    </Typography>
                </CardContent>
                {formatAuthor(video) !== "" && (
                    <CardActions>
                        <Avatar sx={{ width: 34, height: 34 }}>{formatAuthor(video).charAt(0)}</Avatar>
                        <Typography fontSize={14} fontWeight={700} marginLeft={1}>
                            {formatAuthor(video)}
                        </Typography>
                    </CardActions>
                )}
            </div>
            {/* 3-dot menu integration */}
            <div style={{ position: "absolute", top: 8, right: 8 }}>
                <VideoCardMenuV2
                    video={video}
                    refetch={() => {}}
                    onMenuClose={() => setShowMenu(false)}
                    isDetailedPage={false}
                    project={project}
                />
            </div>
            {showVariationReview && (
                <VariationReviewModal
                    open={showVariationReview}
                    onClose={() => setShowVariationReview(false)}
                    project={project}
                    variationFile={video}
                />
            )}
            {onDelete && (
                <IconButton onClick={onDelete}>
                    <Delete></Delete>
                </IconButton>
            )}
        </Card>
    );
}
